import * as p from '@clack/prompts'
import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'
import { cancelAndExit } from '@cli-utils/terminal.js'
import { fail } from '../schema-prompts/fail.js'
import { presetIdFromOwner } from './preset-id-from-owner.js'
import { promptConfirm } from './prompt-confirm.js'

export async function confirmWarningCases(
  owner: SchemaOwner,
  firstTimeGeneration: boolean,
  requiredPersistedField: boolean,
  nonInteractive: boolean,
  yes: boolean | undefined,
  extraWarnings: string[] = []
): Promise<void> {
  const warnings: string[] = [...extraWarnings]
  const presetId = presetIdFromOwner(owner)
  if (presetId) {
    warnings.push(
      `Schema is preset-owned by "${presetId}". Removing that preset can remove the customized schema JSON, generated files, snapshots, and ownership entry.`
    )
  }
  if (firstTimeGeneration) {
    warnings.push('Schema JSON exists but no per-schema snapshot manifest was found.')
  }
  if (requiredPersistedField) {
    warnings.push(
      'Required persisted Entity/Single fields may need manual handling for existing rows.'
    )
  }

  if (warnings.length === 0) {
    return
  }

  if (nonInteractive) {
    if (!yes) {
      fail(`${warnings.join('\n')}\nRe-run with --yes to confirm these warning cases.`)
    }
    return
  }

  p.note(warnings.join('\n'), 'Warnings')
  const confirmed = await promptConfirm('Continue with these warnings?', true)
  if (!confirmed) {
    cancelAndExit('Add field cancelled.')
  }
}
